import React from 'react';
import DataTable from 'components/data-table';
import {RowItemListGroupPeoPleDetailReception} from 'modules/reception/datatable/detail';
import { header } from "constants/table";

export default class GroupPeople extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
    }
  }

  render() {
    return (
      <div className="items-form">
        <div className="title">
          <div className="rows">
            <div className="col-12">
              <h3>Danh sách đoàn</h3>
            </div>
          </div>
        </div>
        <div className="items-form white-table">
          <div className="rows">
            <div className="col-12">
              <DataTable
                header={header.detailReception.groupMember}
                dataList={this.props.doanDiCung}
                hidePagination={true}
                hideExport={true}>
                <RowItemListGroupPeoPleDetailReception/>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/letter-information/letter-detail/GroupPeople.jsx